/* eslint-disable no-undef */
// @ts-check
import "destyle.css";

import initializer from "./api";
import "./ui.scss";
import "./overwrite.scss";

import {
  addClass,
  createElementFromHTML,
  hasClass,
  removeClass,
} from "./utils";
import { tabs } from "./tabs";

import textures from "./textures.html";

// const moveUIs = new Map([
//   ["ホーム", "home"],
//   ["ズームイン", "zoomIn"],
//   ["ズームアウト", "zoomOut"],
// ]);

const constructTextures = (textures) => {
  const constructTextures = document.querySelector("#textures");
  constructTextures.innerHTML = textures;
  // return textures;
};

const constructBaseMaps = (api) => {
  const mapLayersElement = document.querySelector("#map-layers");
  const baseMapsWrapperElement = createElementFromHTML("div", "base-maps", "");
  api.getBaseMaps().forEach((base) => {
    const button = createElementFromHTML(
      "button",
      base.selected ? "active" : "",
      base.layer_name
    );
    button.addEventListener("click", () => {
      Array.from(
        document.querySelectorAll("#map-layers .base-maps button.active")
      ).forEach((el) => {
        removeClass(el, "active");
      });
      addClass(button, "active");

      const layer_id = base.id;
      api.setBaseMap(layer_id);
    });
    baseMapsWrapperElement.appendChild(button);
  });
  mapLayersElement.appendChild(baseMapsWrapperElement);
};

const constructOverlayMaps = (api) => {
  const mapLayersElement = document.querySelector("#map-layers");
  const overlayMapsWrapperElement = createElementFromHTML(
    "div",
    "overlay-maps",
    ""
  );
  api.getOverlayMaps().forEach((overlay) => {
    const button = createElementFromHTML(
      "button",
      overlay.selected ? "active" : "",
      overlay.layer_name
    );
    button.addEventListener("click", () => {
      if (hasClass(button, "active")) {
        removeClass(button, "active");
      } else {
        addClass(button, "active");
      }

      const layer_id = overlay.id;
      api.toggleOverlay(layer_id);
    });
    overlayMapsWrapperElement.appendChild(button);
  });
  mapLayersElement.appendChild(overlayMapsWrapperElement);
};

/**
 * 芳名録用モーダル生成処理
 * @param {*} api
 * @param {*} sponsors
 * @param {*} sponsorMessage
 */
const constructSponsors = (api, sponsors, sponsorMessage) => {
  const mapLayersElement = document.querySelector("#map-layers");
  const sponsorsModalElement = document.querySelector("#sponsors-modal");

  const sponsorsModalFooterElement =
    sponsorsModalElement.querySelector(".footer");
  const message = document.createElement("span");
  message.textContent = sponsorMessage;
  sponsorsModalFooterElement?.insertAdjacentElement("afterbegin", message);

  const sponsorsModalMainElement = sponsorsModalElement.querySelector(".main");

  const overlayMapsWrapperElement = createElementFromHTML(
    "div",
    "overlay-maps",
    ""
  );

  const button = createElementFromHTML("button", "", "芳名録");
  button.addEventListener("click", () => {
    if (hasClass(sponsorsModalElement, "hidden")) {
      removeClass(sponsorsModalElement, "hidden");
    } else {
      addClass(sponsorsModalElement, "hidden");
    }
  });
  document
    .querySelectorAll("#sponsors-modal .close-button")
    .forEach((button) => {
      button.addEventListener("click", () => {
        addClass(sponsorsModalElement, "hidden");
      });
    });

  overlayMapsWrapperElement.appendChild(button);
  mapLayersElement.appendChild(overlayMapsWrapperElement);

  const createNameElement = (name) => {
    const span = document.createElement("span");
    span.textContent = name;
    return span.outerHTML;
  };

  const pts = Object.keys(sponsors)
    .map((key) =>
      // @ts-ignore
      parseFloat(/^p(?<fontSize>\d+.?\d*)pt$/g.exec(key).groups.fontSize)
    )
    .sort((a, b) => b - a);

  sponsorsModalMainElement.innerHTML = pts
    .map((pt) => {
      const div = document.createElement("div");
      div.classList.add("row");
      div.style.fontSize = `${pt}pt`;
      div.innerHTML = sponsors[`p${pt}pt`].map(createNameElement).join("");
      return div.outerHTML;
    })
    .join("");
};

/**
 * 注釈用モーダル生成処理
 * @param {*} api
 * @param {*} notes
 * @param {*} noteMessage
 */
const constructNotes = (api, notes, noteMessage) => {
  const mapLayersElement = document.querySelector("#map-layers");
  const notesModalElement = document.querySelector("#notes-modal");

  // const notesModalFooterElement =
  //   notesModalElement.querySelector(".footer");
  // const message = document.createElement("span");
  // message.textContent = noteMessage;
  // notesModalFooterElement?.insertAdjacentElement("afterbegin", message);

  const notesModalMainElement = notesModalElement.querySelector(".main");

  const overlayMapsWrapperElement = createElementFromHTML(
    "div",
    "overlay-maps",
    ""
  );

  const button = createElementFromHTML("button", "", "注釈");
  button.addEventListener("click", () => {
    if (hasClass(notesModalElement, "hidden")) {
      removeClass(notesModalElement, "hidden");
    } else {
      addClass(notesModalElement, "hidden");
    }
  });
  document.querySelectorAll("#notes-modal .close-button").forEach((button) => {
    button.addEventListener("click", () => {
      addClass(notesModalElement, "hidden");
    });
  });

  overlayMapsWrapperElement.appendChild(button);
  mapLayersElement.appendChild(overlayMapsWrapperElement);

  const createNameElement = (name) => {
    const span = document.createElement("span");
    span.textContent = name;
    return span.outerHTML;
  };

  notesModalMainElement.innerHTML = notes;
  // const pts = Object.keys(notes)
  //   .map((key) =>
  //     // @ts-ignore
  //     parseFloat(/^p(?<fontSize>\d+.?\d*)pt$/g.exec(key).groups.fontSize)
  //   )
  //   .sort((a, b) => b - a);

  // notesModalMainElement.innerHTML = pts
  //   .map((pt) => {
  //     const div = document.createElement("div");
  //     div.classList.add("row");
  //     div.style.fontSize = `${pt}pt`;
  //     div.innerHTML = notes[`p${pt}pt`].map(createNameElement).join("");
  //     return div.outerHTML;
  //   })
  //   .join("");
};

const createTabButtonContent = (category) => {
  const img = createElementFromHTML("img");

  if (category.startsWith("水利灌漑図")) {
    img.src = "./assets/map-suirikangai.svg";
  } else if (category === "寺社・遺跡・土地情報") {
    img.src = "./assets/map-jisha.svg";
  } else if (category === "地籍図") {
    img.src = "./assets/map-jisha.svg";
  } else {
    console.warn(category);
    return category;
  }

  const span = createElementFromHTML("span", "", category);
  const body = [img, span].map((el) => el?.outerHTML).join("");
  const wrapper = createElementFromHTML("div", "", body).outerHTML;
  return wrapper;
};

/**
 * @param {PromiseType<ReturnType<import("./api").default>>} api
 */
const constructTabs = (api) => {
  const tabsElement = document.querySelector("#tab-container .tabs");
  const tabpane = document.querySelector("#tab-container .tab-panes");
  const myTabs = new Map();

  const isAllLayerShown = (category1) => {
    const layers = api.getVectorLayersByCategory1(category1);
    return layers.every(({ id }) => api.isShowLayerById(id));
  };

  api.getVectorLayers().forEach((vector) => {
    const category = vector.category1;
    const showAllButton = createElementFromHTML(
      "button",
      "toggle-all",
      "全て表示"
    );

    if (!myTabs.has(category)) {
      const tabdatum = createElementFromHTML("div", "tab-pane");
      const tabButton = createElementFromHTML(
        "button",
        "tab",
        createTabButtonContent(category)
      );

      tabsElement.appendChild(tabButton);
      tabpane.appendChild(tabdatum);

      showAllButton.addEventListener("click", () => {
        const layers = api.getVectorLayersByCategory1(category);

        if (isAllLayerShown(category)) {
          layers.forEach(({ id }) => {
            api.hiddenVectorLayerById(id);
          });
          myTabs
            .get(category)
            .querySelectorAll("button")
            .forEach((el) => {
              removeClass(el, "active");
            });
          showAllButton.innerText = "全て表示";
          removeClass(showAllButton, "active");
        } else {
          layers.forEach(({ id }) => {
            api.showVectorLayerById(id);
          });
          myTabs
            .get(category)
            .querySelectorAll("button")
            .forEach((el) => {
              addClass(el, "active");
            });
          showAllButton.innerText = "全て非表示";
          addClass(showAllButton, "active");
        }
      });
      tabdatum.appendChild(showAllButton);

      myTabs.set(category, tabdatum);
    }

    const layerButton = createElementFromHTML("button", "", vector.layer_name);
    layerButton.addEventListener("click", () => {
      const button = document.querySelector(
        "div.tab-pane.active button.toggle-all"
      );
      const layer_id = vector.id;
      api.toggleVectorLayers(layer_id);
      const { selected } = api.getVectorLayerById(layer_id);
      if (selected) {
        addClass(layerButton, "active");
      } else {
        removeClass(layerButton, "active");
      }

      if (isAllLayerShown(category)) {
        addClass(button, "active");
        button.textContent = "全て非表示";
      } else {
        removeClass(button, "active");
        button.textContent = "全て表示";
      }
    });

    myTabs.get(category).appendChild(layerButton);
  });

  tabs(document.querySelector("#tab-container"));
};

const constructPans = (api) => {
  const pans = ["panNorth", "panEast", "panSouth", "panWest"];

  pans.forEach((id) => {
    document.getElementById(id).addEventListener("click", () => {
      api[id]();
    });
  });
};

export default async function ui(areaJson) {
  const api = await initializer(areaJson);

  api.setBaseMap(api.settings.bases[0].id);

  constructOverlayMaps(api);
  constructBaseMaps(api);
  constructTabs(api);
  constructPans(api);
  constructTextures(textures);
  // constructNotes(api, notes, noteMassage);
  // @ts-expect-error
  if (typeof notes !== "undefined") {
    // @ts-expect-error
    constructNotes(api, notes);
  }
  if (typeof sponsors !== "undefined") {
    // @ts-expect-error
    constructSponsors(api, sponsors, sponsorMessage);
  }

  document.getElementById("home-button").addEventListener("click", () => {
    location.reload();
  });
}
